import { ensureError, ensureHelp, ensureLabel, type FieldType } from './base.js';
import { validateRequired } from '../validation.js';
import { ensureInput, withCustomMessage } from './text.js';

export const dateType: FieldType = {
  render(ctx) {
    ensureLabel(ctx.host, ctx.label, ctx.required);
    const input = ensureInput(ctx, 'date');
    const min = ctx.host.getAttribute('min');
    const max = ctx.host.getAttribute('max');
    if (min) input.min = min;
    if (max) input.max = max;
    ensureError(ctx.host);
    ensureHelp(ctx.host, ctx.help);
  },

  getValue(ctx) {
    return ctx.host.querySelector<HTMLInputElement>(':scope > input')?.value ?? '';
  },

  validate(ctx) {
    const value = String(this.getValue(ctx));
    if (ctx.required) return withCustomMessage(validateRequired(value), ctx);
    return { valid: true };
  },

  shouldSubmit() {
    return true;
  },

  setDisabled(ctx, disabled) {
    const input = ctx.host.querySelector<HTMLInputElement>(':scope > input');
    if (input) input.disabled = disabled;
  },
};
